let katexReady: Promise<boolean> | null = null

export function loadKatex(): Promise<boolean> {
    if (katexReady) return katexReady

    katexReady = (async () => {
        try {
            const [{ default: katex }, { default: renderMathInElement }] = await Promise.all([
                import('katex'),
                import('katex/contrib/auto-render'),
                import('katex/dist/katex.min.css')
            ])
            const w = window as any
            w.katex = katex
            w.renderMathInElement = renderMathInElement
            return true
        } catch (e) {
            console.error('[KaTeX] Error cargando chunk local', e)
            katexReady = null // permite reintentar
            return false
        }
    })()

    return katexReady
}

// let katexReady: Promise<boolean> | null = null

// export function loadKatex(timeoutMs = 5000): Promise<boolean> {
//     if (katexReady) return katexReady

//     katexReady = (async () => {
//         const loadCSS = (url: string) =>
//             new Promise<boolean>((resolve) => {
//                 const link = document.createElement('link')
//                 link.rel = 'stylesheet'
//                 link.href = url

//                 link.onload = () => {
//                     // console.info(`[KaTeX] CSS cargado: ${url}`)
//                     resolve(true)
//                 }

//                 link.onerror = () => {
//                     console.error(`[KaTeX] Error cargando CSS: ${url}`)
//                     resolve(false)
//                 }

//                 document.head.appendChild(link)
//             })

//         const loadScript = (url: string) =>
//             new Promise<boolean>((resolve) => {
//                 const s = document.createElement('script')
//                 s.src = url
//                 s.async = true

//                 s.onload = () => {
//                     // console.info(`[KaTeX] Script cargado: ${url}`)
//                     resolve(true)
//                 }

//                 s.onerror = () => {
//                     console.error(`[KaTeX] Error cargando script: ${url}`)
//                     resolve(false)
//                 }

//                 document.head.appendChild(s)
//             })

//         let timeoutId: number | null = null

//         const timeout = new Promise<boolean>((resolve) => {
//             timeoutId = window.setTimeout(() => {
//                 console.error(`[KaTeX] Timeout después de ${timeoutMs}ms`)
//                 resolve(false)
//             }, timeoutMs)
//         })

//         const cssUrl = 'https://cdn.jsdelivr.net/npm/katex@0.17.0/dist/katex.min.css'
//         const jsUrl = 'https://cdn.jsdelivr.net/npm/katex@0.17.0/dist/katex.min.js'
//         const autoUrl = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js'

//         // CSS
//         const okCss = await Promise.race([loadCSS(cssUrl), timeout])
//         if (!okCss) return false

//         // KaTeX core
//         const okJs = await Promise.race([loadScript(jsUrl), timeout])
//         if (!okJs) return false

//         // Auto-render
//         const okAuto = await Promise.race([loadScript(autoUrl), timeout])
//         if (!okAuto) return false

//         if (timeoutId !== null) clearTimeout(timeoutId)

//         if (typeof (window as any).katex === 'undefined') {
//             console.error('[KaTeX] Script cargado pero "katex" no está disponible')
//             return false
//         }

//         if (typeof (window as any).renderMathInElement === 'undefined') {
//             console.error(
//                 '[KaTeX] Auto-render cargado pero "renderMathInElement" no está disponible'
//             )
//             return false
//         }

//         // console.info('[KaTeX] KaTeX + auto-render listos')
//         return true
//     })()

//     return katexReady
// }
